function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1C5.486 1 1 5.486 1 11s4.486 10 10 10c.225 0 .445-.018.666-.033a6.972 6.972 0 0 1-.588-1.97h-.006A7 7 0 0 1 18 11c.339-.001.671.025.996.073v.004a6.9 6.9 0 0 1 1.97.59c.016-.222.034-.443.034-.668 0-5.514-4.486-10-10-10zm-.01 4h.02a.99.99 0 0 1 .99.99v5.014a.986.986 0 0 1-.29.7l-3.304 3.304a.987.987 0 0 1-1.398 0l-.016-.016a.987.987 0 0 1 0-1.398L10 10.586V5.99a.99.99 0 0 1 .99-.99zM18 13a5 5 0 1 0 .001 10.001A5 5 0 0 0 18 13zm2.05 3.06a.99.99 0 0 1 .7 1.69L18.2 20.3a.987.987 0 0 1-1.4 0l-1.55-1.55a.99.99 0 1 1 1.4-1.4l.85.85 1.85-1.85a.988.988 0 0 1 .7-.29z"
});

var SvgIcIdentityCheckingRound = function SvgIcIdentityCheckingRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcIdentityCheckingRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_identity_checking_round.3b6760ec.svg";
export { ForwardRef as ReactComponent };